import _ from 'lodash';
import { observable, action } from 'mobx';
import type { ChargingDepartmentShareMappingArgs } from './charging_department_share_mapping';
import ChargingDepartmentShareMapping from './charging_department_share_mapping';

class ChargingDepartmentShareMappingList {
  @observable public list: ChargingDepartmentShareMapping[];

  constructor(raw: ChargingDepartmentShareMappingArgs[]) {
    this.list = raw.map(o => new ChargingDepartmentShareMapping(o));
  }

  find(id: number) {
    return _.find(this.list, o => o.id === id);
  }

  last() {
    return _.last(this.list);
  }

  @action
  push(o: ChargingDepartmentShareMapping) {
    this.list.push(o);
  }

  @action
  remove(o: ChargingDepartmentShareMapping) {
    const i = this.list.indexOf(o);
    if (i > -1) {
      this.list.splice(i, 1);
    }
  }

  @action
  update(newOrg: ChargingDepartmentShareMapping) {
    const o = this.find(newOrg.id);
    if (o) {
      _.assign(o, newOrg);
    }
  }
}

export default ChargingDepartmentShareMappingList;
